import React, { useState } from "react";
import Dialog from "../../../GenericComponents/dialog";
import { FoundationsButton } from "../../../GenericComponents/button";
import { useDetachWorkspaceMutation } from "../../../Redux/Workspace/workspaceActionsSlice";
import { FoundationsGenericToaster } from "../../../GenericComponents/FoundationsGenericToaster";
import { useNavigate } from "react-router-dom";
import { FoundationsConstants } from "../../../FoundationsConstants";

interface DetachWorkspaceDialogProps {
  isOpen: boolean;
  onClose: () => void;
  WorkspaceId: string;
  detachCallback?: any;
}

declare let window: any
const UnicornApp = window.unicornInstance as any

const DetachWorkspaceDialog: React.FC<DetachWorkspaceDialogProps> = ({ isOpen, onClose, WorkspaceId, detachCallback }) => {

  const [detachWorkspace] = useDetachWorkspaceMutation();
  const navigate = useNavigate();
  const handleDetachWorkspace = (WorkspaceId: string) => {
    const formData = new FormData();
    formData.append("dashBoardId", WorkspaceId);

    detachWorkspace(formData)
      .unwrap()
      .then((response) => {
        if (response?.statusCode === 201) {
          const resultData = response.data;
          if (resultData) {
            if (resultData.MessageResults) {
              // Check success or failure messages from the API response
              resultData.MessageResults.forEach((messageResult: { HelpMessage: string; Message: any; }) => {
                if (messageResult.HelpMessage === FoundationsConstants.Response.Success) {
                  FoundationsGenericToaster("success", messageResult.Message);
                  if(typeof detachCallback === "function") 
                  {
                    detachCallback({
                      WorkspaceId: WorkspaceId
                    })
                  }                  
                  navigate('#home?ref=detach_workspace', { replace: true });
                  onClose()
                } else {
                  FoundationsGenericToaster("error", messageResult.Message);
                }
              });
            } else {
              FoundationsGenericToaster("error", "Workspace detach failed.");
            }
          }
        } else if (response?.statusCode === 403) {
          FoundationsGenericToaster("error", "Sorry, you do not have permission to complete this operation.");
        }
      })
      .catch((error) => {
        FoundationsGenericToaster("error", "Failed to detach workspace.");
      });
  };

  return (
    <Dialog
      isOpen={isOpen}
      title="Detach (Release) Workspace"
      onClose={onClose}
      className="left-align-text"
      buttons={[
        {
          label: "Cancel",
          id: "cancel-detach-workspace",
          onClick: onClose,
          className: "ui-button ui-corner-all ui-widget app-button negative",
        },
        {
          label: "Detach Workspace",
          id: "detach-workspace-button",
          onClick: () => {
            handleDetachWorkspace(WorkspaceId);
          },
          className: "ui-button ui-corner-all ui-widget app-button",
        }
      ]}
    >
      <div id="detach_dashboard_dialog_wrapper"
        className="hide ui-dialog-content ui-widget-content"
        style={{
          display: "block",
          width: "auto",
          minHeight: "43.6px",
          maxHeight: "none",
          height: "auto",
        }}
      >
        <div className="panel-popup-window">
          <div id="detach_dashboard_warning">
            <p>Please confirm you would like to detach </p>
            <p>(release) this workspace from your user account</p>
          </div>
        </div>
        <span id="detach_dashboard_loading" className="hide ajax-loading-box popup-loading"><span className="ajax-loading-image">Detaching...</span></span>
      </div>
    </Dialog>
  );
};

export default DetachWorkspaceDialog;